export default __webpack_public_path__ + "static/media/CHIEF Calendar Time Views.11012ba3.png";